<template>
	<div v-cloak class="exams">
		<div class="breadcrumb">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: paths }">{{ title }}</el-breadcrumb-item>
				<el-breadcrumb-item>测试</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<!-- 测试题目 -->
		<div style="text-align: center;color:#000000;font-size:20px;">{{ examtitle }}</div>
		<div v-show="status" class="topic">
			<!-- 左边 -->
			<div v-cloak class="topic-left">
				<!-- 单选 -->
				<div v-for="(rexam, index) in radios" :key="index" class="topic-list">
					<div :class="!rexam.IsRight ? 'topic-titless' : 'topic-title'">
						{{ index + 1 }}. {{ rexam.Title }}
						<!-- <span class="IsRequired" v-show="rexam.IsRequired">*</span> -->
					</div>
					<el-radio-group class="xuan" v-model="rs">
						<el-radio disabled v-for="(rexams, indexs) in rexam.AnswerItems" :key="indexs" :label="rexams.Checked ? 1 : 0">{{ rexams.Title }}</el-radio>
					</el-radio-group>
					<div v-if="rexam.IsParse" class="parse">
						<div style="margin-bottom: 15px;">题目解析:</div>
						<div>{{ rexam.Parse }}</div>
					</div>
				</div>
				<!-- 多选 -->
				<div v-for="(cexam, item) in checks" :key="item + 10" class="topic-list">
					<div :class="!cexam.IsRight ? 'topic-titless' : 'topic-title'">
						<!-- {{ (len + item + 1) | che() }}{{ cexam.Title }} -->
						{{ dx + item }}.{{ cexam.Title }}
						<span class="IsRequired">(多选)</span>
						<!-- <span class="IsRequired" v-show="cexam.IsRequired">*</span> -->
					</div>
					<el-checkbox-group v-model="cs">
						<el-checkbox disabled v-for="(cexams, indexs) in cexam.AnswerItems" :key="indexs" :label="cexams.Checked ? 1 : 0">{{ cexams.Title }}</el-checkbox>
					</el-checkbox-group>
					<div v-if="cexam.IsParse" class="parse">
						<div style="margin-bottom: 15px;">题目解析:</div>
						<div>{{ cexam.Parse }}</div>
					</div>
				</div>
				<!-- 多文本 -->
			</div>
			<!-- 右边 -->
			<div class="topic-right">
				<div class="exam-right">
					<div class="titles-right">考试信息</div>
					<div class="mes">
						<!-- <div>开始时间：{{ examtime }}</div> -->
						<div>完成时间：{{ endtime }}</div>
						<!-- <div>答题限时：{{ examlimit }}分</div> -->
						<div>
							考试:
							<span style="font-size: 25px;">{{ hk }}</span>
						</div>
						<div style="color:red;font-size:14px;">不合格的请到个人中心我的测试重新考试</div>
					</div>
				</div>
			</div>
		</div>
	<!-- 考试合格显示 -->
  <el-dialog :visible.sync="dialogTableVisible" width="30%">
    <div class="t-center ma-t-20">
      <img :src="dialogImgUrl" alt="" srcset="" width="100%">
    </div>
  </el-dialog>
	</div>
</template>
<style lang="scss" scoped>
    /* 大屏 宽度大于768 */
    @media (min-width: 768px) {
        .exams {
            min-width: 1200px;
            min-height: 500px;
            background: #ffffff;

            .duo {
                margin-top: 10px;

                .el-textarea__inner {
                    border-radius: 12px;
                    border: 1px solid rgba(151, 151, 151, 1);
                }
            }

            .breadcrumb {
                width: 1200px;
                margin: 0 auto;
                margin-top: 38px;
                margin-bottom: 65px;
            }

            .topic {
                width: 1200px;
                padding-bottom: 60px;
                box-sizing: border-box;
                // height: 900px;
                display: flex;
                justify-content: flex-start;
                margin: 0 auto;

                .parse {
                    width: 100%;
                    margin-top: 10px;
                    background: rgba(15, 117, 189, 1);
                    border-radius: 12px;
                    font-size: 14px;
                    font-family: MicrosoftYaHei;
                    color: rgba(255, 255, 255, 1);
                    box-sizing: border-box;
                    padding: 25px 45px;
                }

                .IsRequired {
                    color: red;
                }

                .topic-left {
                    width: 900px;
                    margin-top: 40px;

                    .topic-title {
                        font-size: 14px;
                        font-family: MicrosoftYaHei;
                        color: #000000;
                    }

                    .topic-titless {
                        font-size: 14px;
                        font-family: MicrosoftYaHei;
                        color: red;
                    }

                    .topic-list {
                        margin-bottom: 30px;

                        .el-radio__input.is-checked .el-radio__inner {
                            border-color: #000000;
                            background: #000000;
                        }

                        .el-radio__label {
                            color: #767676;
                        }

                        .el-radio__inner:hover {
                            border-color: #000000;
                        }

                        .el-checkbox__input.is-checked .el-checkbox__inner {
                            border-color: #000000;
                            background: #000000;
                        }

                        .el-checkbox__input.is-checked + .el-checkbox__label {
                            color: #767676;
                        }

                        .el-checkbox__inner:hover {
                            border-color: #000000;
                        }
                    }

                    .xuan {
                        display: flex;
                        flex-direction: column;

                        .el-radio {
                            margin-top: 21px;
                            font-size: 14px;
                            font-family: MicrosoftYaHei;
                            color: rgba(118, 118, 118, 1);
                        }
                    }

                    .el-checkbox-group {
                        display: flex;
                        flex-direction: column;

                        .el-checkbox {
                            margin-top: 21px;
                            font-size: 14px;
                            font-family: MicrosoftYaHei;
                            color: rgba(118, 118, 118, 1);
                        }
                    }

                    .subs {
                        width: 294px;
                        height: 54px;
                        background: rgba(15, 117, 189, 1);
                        font-size: 20px;
                        font-family: MicrosoftYaHei;
                        color: rgba(255, 255, 255, 1);
                        line-height: 54px;
                        text-align: center;
                        margin-top: 56px;
                        cursor: pointer;
                    }
                }

                .topic-right {
                    width: 260px;
                    height: 100%;
                    // position:fixed;
                    // top:50%;
                    // right:0;

                    .exam-right {
                        width: 260px;
                        background: #ffffff;
                        // z-index: 9999999999;

                        box-sizing: border-box;
                    }

                    .titles-right {
                        font-size: 20px;
                        font-family: MicrosoftYaHei;
                        color: rgba(0, 0, 0, 1);
                        margin-bottom: 24px;
                    }

                    .titles-right:before {
                        content: '|';
                        display: inline-block;
                        width: 4px;
                        height: 26px;
                        background: rgba(15, 117, 189, 1);
                        color: rgba(15, 117, 189, 1);
                        border-radius: 2px;
                        margin-right: 8px;
                    }

                    .mes {
                        font-size: 14px;
                        font-family: MicrosoftYaHei;
                        color: rgba(0, 0, 0, 1);
                        margin-bottom: 30px;

                        div {
                            margin-top: 15px;
                        }

                        span {
                            font-size: 30px;
                            font-family: MicrosoftYaHei;
                            color: rgba(15, 117, 189, 1);
                        }
                    }

                    .clip {
                        display: flex;
                        justify-content: flex-start;
                        flex-wrap: wrap;

                        .clip-list {
                            width: 40px;
                            height: 40px;
                            border: 1px solid rgba(209, 219, 234, 1);
                            text-align: center;
                            line-height: 40px;
                            font-size: 14px;
                            font-family: MicrosoftYaHei;
                            color: #000000;
                            background: #ffffff;
                            cursor: pointer;
                            // background: rgba(15, 117, 189, 1);
                        }

                        .active {
                            width: 40px;
                            height: 40px;
                            border: 1px solid rgba(209, 219, 234, 1);
                            text-align: center;
                            line-height: 40px;
                            font-size: 14px;
                            font-family: MicrosoftYaHei;
                            color: #ffffff;
                            background: rgba(15, 117, 189, 1);
                            cursor: pointer;
                        }

                        .clip-b {
                            font-size: 12px;
                            font-family: MicrosoftYaHei;
                            color: rgba(118, 118, 118, 1);
                            margin-top: 15px;
                        }
                    }
                }
            }
        }
    }
</style>
<script>
    import { lookexam } from '../api.js';
    export default {
        name: 'Exam-detail',
        components: {},
        data() {
            return {
                dialogTableVisible: false,
                dialogImgUrl: '',
                test: [],
                rs: 1,
                cs: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
                radio: [], //单选model数组
                radioend: [], //选中的单选题数组
                checkList: [], //多选model数组
                checkend: [], //多选答案数组
                paths: '', //上一级路由地址
                title: '', //上一级路由名称
                radios: [], //单选题数组
                checks: [], //多选数组
                ExamSubmitId: '', //考试结果id
                len: '', //单选题目长度
                checklen: '', //多选题目长度
                examid: '', //考试id
                kid: '', //课程id
                examtitle: '', //考试标题
                examtime: '', //开始时间
                endtime: '', //结束时间
                examlimit: '', //考试限时
                examscore: '', //考试总分
                realtime: 0, //实时时间
                timer: null,
                loading: false,
                sid: '', //学习id
                status: false,
                hk: '' //合格是否
            };
        },
        created() {
            let path = this.$route.query.paths;
            let titles = this.$route.query.name;
            this.paths = path;
            this.title = titles;
            this.ExamSubmitId = this.$route.query.ExamSubmitId;
            this.titles();
        },
        filters: {},
        computed: {
            dx() {
                let len = this.len;
                return len + 1;
            },
            dw() {
                let len = this.len;
                let checklen = this.checklen;
                let dws = checklen + len;
                return dws + 1;
            }
        },
        beforeRouteLeave(to, from, next) {
            console.log(from)
            if (to.path == '/creation/detail') {
                localStorage.setItem('second', 1)
            }
            next()
        },

        methods: {
            // 刷选单选多选
            screen() {
                let test = this.test;
                // 单选
                let radio = test.filter(radios => {
                    return radios.InputType == 'radio';
                });

                this.radios = radio;
                this.len = this.radios.length;

                // 多选
                let check = test.filter(checks => {
                    return checks.InputType == 'checkbox';
                });

                this.checks = check;
                this.checklen = this.checks.length;
            },
            //获取结果题目
            titles() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: '#0000000'
                });
                let ExamSubmitId = this.ExamSubmitId;
                let token = localStorage.getItem('AccessToken');
                let datas = {
                    id: ExamSubmitId,
                    token: token,
                    source: 'pc'
                };

                lookexam(datas)
                    .then(res => {
                        // console.log(res)
                        if (res.data.Code == 0) {

                            let response = res.data.Data.Exam;
                            this.status = true;
                            this.test = res.data.Data.List;
                            this.examtime = response.StartTime; //开始时间
                            this.endtime = response.EndTime; //结束时间
                            this.examlimit = response.LimitTime; //限时
                            this.hk = response.ExamResult;
                            this.screen();
                            loading.close();
                            if (response.ExamResult == '合格') {
                                this.dialogTableVisible = true;
                                this.dialogImgUrl = response.CertificatePath
                            }
                        } else {
                            loading.close();
                        }
                    })
                    .catch(error => {
                        loading.close();
                        console.log(error);
                    });
            }
        }
    };
</script>
